import { ArrowRightIcon } from "@wags/ui/product-icons.tsx";
import { ListingDescriptionMarkdown } from "./listing-description-markdown";

export type FaqAskSource = "typed" | "follow_up";

export type FaqActiveAsk = {
    question: string;
    source: FaqAskSource;
    reply: { state: "pending" | "answered" | "failed"; text: string };
    stalled: boolean;
};

const STATUS_COPY = {
    pending: "Kits is looking into it…",
    stalled: "Kits is taking longer than usual. Pick it up in the chat.",
    answered: "Kits replied in the chat.",
    failed: "Kits couldn't answer here. Try it in the chat.",
} as const;

export function FaqKitsAnswer({
    ask: { question, reply, stalled },
    onContinue,
}: {
    ask: FaqActiveAsk;
    onContinue: () => void;
}) {
    const state =
        stalled && reply.state === "pending" && !reply.text
            ? "stalled"
            : reply.state;
    const pending = state === "pending";
    return (
        <div className="mt-3 rounded-md bg-doberman-black/5 p-4">
            <p className="text-body-small text-pretty text-doberman-black/60">
                {question}
            </p>
            <div aria-live="polite" aria-busy={pending} className="mt-1">
                {reply.text ? (
                    <ListingDescriptionMarkdown className="[&_p]:text-pretty [&_p]:text-doberman-black">
                        {reply.text}
                    </ListingDescriptionMarkdown>
                ) : (
                    <p
                        className={
                            pending
                                ? "text-body text-doberman-black/60 motion-safe:animate-pulse"
                                : "text-body text-pretty text-doberman-black"
                        }
                    >
                        {STATUS_COPY[state]}
                    </p>
                )}
            </div>
            {!pending && (
                <button
                    type="button"
                    onClick={onContinue}
                    className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-doberman-black/10 bg-true-white px-3.5 py-2 text-label text-doberman-black transition-transform active:scale-96 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow motion-reduce:transition-none motion-reduce:active:scale-100"
                >
                    Keep talking with Kits
                    <ArrowRightIcon aria-hidden="true" className="size-4" />
                </button>
            )}
        </div>
    );
}
